import { useEffect } from 'react';
import { Box } from 'src/components/UI/Box';
import { Flex } from 'src/components/UI/Flex';
import { ReactComponent as Allegril } from 'src/assets/mevo-pill/allegril.svg';
import { StoreDownloadSection } from './components/StoreDownloadSection';
import { NavigationButtons } from './components/NavigationButtons';
import {
  trackOnboardingSuccessView,
  trackOnboardingSuccessBackClick,
  trackOnboardingSuccessContinueClick,
} from 'src/services/tracking/events/onboarding.events';

interface OnboardingSuccessProps {
  onFinish: () => void;
  onBack: () => void;
}

export function OnboardingSuccess({ onFinish, onBack }: OnboardingSuccessProps) {
  const handleBack = () => {
    trackOnboardingSuccessBackClick();
    onBack();
  };

  const handleFinish = () => {
    trackOnboardingSuccessContinueClick();
    onFinish();
  };

  return (
    <Box w="100%" h="90%" pr={{ base: '0', lg: '10%' }} display="flex" flexDirection="column">
      <Flex direction="column" h="100%" w="100%">
        <Box flexShrink={0}>
          <Flex direction="row" justifyContent="space-between" width={'100%'} w="100%">
            <Box mb="24px">
              <Box as="h1" fontSize="30px" fontWeight="bold" color="gray.900" lineHeight="1.2">
                Comece a prescrever agora!
              </Box>
              <Box mt={'40px'} as="h3" fontSize="16px" fontWeight="bold" color="gray.900">
                Boas vindas, suas informações foram salvas com sucesso!
              </Box>
              <Box
                as="p"
                fontFamily={'Ambit'}
                fontStyle={'semibold'}
                fontSize="14px"
                fontWeight={'500'}
                color="gray.800"
              >
                Agora você tem total acesso para cadastrar pacientes, emitir receitas e documentos.
              </Box>
            </Box>

            <Flex w="100px" h="100px" borderRadius="50%" bg="secondary.100" align="center" justify="center" mb="32px">
              <Box transform="scale(0.65)">
                <Allegril />
              </Box>
            </Flex>
          </Flex>

          <Box mb="24px"></Box>
        </Box>

        <StoreDownloadSection />

        <Box mt="auto" pt="32px">
          <NavigationButtons onBack={handleBack} onNext={handleFinish} nextLabel="Acessar" />
        </Box>
      </Flex>
    </Box>
  );
}
